var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',[(_vm.creationTime)?_c('span',[_vm._v(_vm._s(_vm.$t("registered") + ": " + _vm.creationTime)+" ")]):_vm._e(),_c('br'),(_vm.lastLogin)?_c('span',[_vm._v(_vm._s(_vm.$t("lastLogin") + ": " + _vm.lastLogin))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }